import { Link } from 'react-router-dom'
import { categories } from '@/mocks/categories'

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            完整分类导航
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            按不同维度精心分类，帮助您快速定位感兴趣的内容类型，发现更多优质色里番作品。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-xl ${cat.colorClass} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${cat.icon} text-background-50 text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {cat.count} 部
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}